@let selectedProfiles = profiles.length === 1 ? [profiles[0]] : profiles;

@for (profile of selectedProfiles; track profile) {
    <a
            [routerLink]="['/directory/institutions', profile.directoryInstitutionRequestKey]"
            [state]="{ activeTab: annualUpdate ? 7 : 1 }"
            mat-menu-item
            routerLinkActive="active"
    >
        @if (annualUpdate) {
            <ng-container>
                <mat-icon fontSet="material-icons-outlined">pending_actions</mat-icon>
                Annual Report
            </ng-container>
        } @else {
            <ng-container>
                <mat-icon fontSet="material-icons-outlined">content_paste_search</mat-icon>
                Directory
            </ng-container>
        }
    </a>
}
